import { getActionAuthorization } from '../commons/utils';

const EXTERNAL_ORDER_ACTIONS_RESOURCE = {
  CREATE_AND_EDIT_DRAFT: 'external-order:create:draft',
  VALIDATE_DRAFT: 'external-order:validate:draft',
  DELETE_DRAFT: 'external-order:delete:draft',
  REVERT_TO_DRAFT: 'external-order:revert:draft',
  EDIT_TO_COME_AND_IN_PREPARATION: 'external-order:edit:to-come',
  REVERT_TO_IN_PREPARATION: 'external-order:revert:in-preparation',
};

/**
 * Gates the creation of a draft order and its edition — including the duplication, which always
 * lands on a new draft whatever the status of the duplicated order.
 */
export const canCreateAndEditDraftExternalOrder = (actions) =>
  getActionAuthorization(actions, EXTERNAL_ORDER_ACTIONS_RESOURCE.CREATE_AND_EDIT_DRAFT);

export const canValidateDraftExternalOrder = (actions) =>
  getActionAuthorization(actions, EXTERNAL_ORDER_ACTIONS_RESOURCE.VALIDATE_DRAFT);

export const canDeleteDraftExternalOrder = (actions) =>
  getActionAuthorization(actions, EXTERNAL_ORDER_ACTIONS_RESOURCE.DELETE_DRAFT);

export const canRevertExternalOrderToDraft = (actions) =>
  getActionAuthorization(actions, EXTERNAL_ORDER_ACTIONS_RESOURCE.REVERT_TO_DRAFT);

/**
 * Gates the edition of the "A venir" and "En préparation" orders, and with it the transition back
 * from "En préparation" to "A venir".
 */
export const canEditToComeAndInPreparationExternalOrder = (actions) =>
  getActionAuthorization(actions, EXTERNAL_ORDER_ACTIONS_RESOURCE.EDIT_TO_COME_AND_IN_PREPARATION);

export const canRevertExternalOrderToInPreparation = (actions) =>
  getActionAuthorization(actions, EXTERNAL_ORDER_ACTIONS_RESOURCE.REVERT_TO_IN_PREPARATION);
